import { render } from "./videoDellaSettimanaViewer.vue?vue&type=template&id=ca9d6628&scoped=true&ts=true"
import script from "./videoDellaSettimanaViewer.vue?vue&type=script&lang=ts"
export * from "./videoDellaSettimanaViewer.vue?vue&type=script&lang=ts"

import "./videoDellaSettimanaViewer.vue?vue&type=style&index=0&id=ca9d6628&scoped=true&lang=css"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9d6628"]])

export default __exports__